import { jsx as s, jsxs as N, Fragment as _ } from "react/jsx-runtime";
import A, { useCallback as P } from "react";
import r from "../../_virtual/index.es.js";
import j from "../../packages/ui/node_modules/react-country-flag/dist/react-country-flag.esm.es.js";
import x from "../generic/ChangeAnimation.es.js";
import l from "../wpr/Wpr.es.js";
import z from "../wtn/Wtn.es.js";
import R from "../../icons/ExpandMore.es.js";
import T from "../../icons/TooltipWarningIcon.es.js";
import { iconStyles as k, nameInfoStyles as B, nameStyles as D, textStyles as M, expandIconStyles as V, styles as $, infoStyles as q } from "./Player.styles.es.js";
const G = A.memo(function({
  adornment: m,
  country: c,
  countryName: e,
  index: f,
  name: u,
  onClick: t,
  player: o,
  showPlayerMenuIndicator: a,
  sideIndex: v,
  wtn: i,
  wpr: n
}) {
  const h = P((b) => {
    t == null || t(b, o || null, v, f);
  }, [f, t, o, v]), g = P(() => m || (c ? /* @__PURE__ */ s("span", { className: k(), children: /* @__PURE__ */ s(j, { svg: !0, alt: e, countryCode: c, loading: "lazy", style: {
    height: "initial",
    verticalAlign: "initial"
  } }) }) : typeof (i == null ? void 0 : i.value) == "number" && Number.isFinite(i.value) ? /* @__PURE__ */ s(z, { confident: !!i.confident, children: i.value }) : typeof (n == null ? void 0 : n.value) == "number" && Number.isFinite(n.value) ? /* @__PURE__ */ s(l, { rated: n.rated, rating: n.value }) : null), [m, c, e, n == null ? void 0 : n.rated, n == null ? void 0 : n.value, i == null ? void 0 : i.confident, i == null ? void 0 : i.value]);
  return /* @__PURE__ */ N(x, { as: o != null && o.link || t ? "a" : "span", className: r(B(), D({
    link: !!(o != null && o.link || t)
  })), ...(o == null ? void 0 : o.link) && {
    href: o.link,
    rel: "noreferrer",
    target: "_blank"
  }, tabIndex: 0, title: u, triggerValue: u, onClick: t && h, children: [
    g(),
    /* @__PURE__ */ s("span", { className: M({
      tbd: !o
    }), children: u }),
    a && /* @__PURE__ */ s(R, { className: V(), size: "16px" })
  ] });
});
function H({
  adornment: d = "country",
  animateOnChange: m = !1,
  className: c,
  completed: e = !1,
  index: f,
  onClick: u,
  player: t,
  showAdditionalInfo: o,
  displayWarning: a,
  warningText: v,
  showPlayerMenuIndicator: i = !1,
  sideIndex: n
}) {
  const h = !t && !e ? "TBD" : t == null ? void 0 : t.name, g = t == null ? void 0 : t.countryName, b = d === "country" ? t == null ? void 0 : t.country : void 0, F = d === "wtn" ? t == null ? void 0 : t.wtn : void 0, E = d === "wpr" ? t == null ? void 0 : t.wpr : void 0, W = d === "custom" ? t == null ? void 0 : t.adornment : void 0, I = t ? t == null ? void 0 : t.additionalInfo : " ", S = t == null ? void 0 : t.decorator;
  return /* @__PURE__ */ N(_, { children: [
    /* @__PURE__ */ N("div", { className: r($(), c), children: [
      /* @__PURE__ */ s(G, { adornment: W, country: b, countryName: g, index: f, name: h, player: t, showPlayerMenuIndicator: i, sideIndex: n, wpr: E, wtn: F, onClick: u }),
      a && /* @__PURE__ */ s(T, { position: "right", text: v }),
      S && /* @__PURE__ */ s(x, { animationEnabled: m, as: "div", children: S })
    ] }),
    o && I && /* @__PURE__ */ s(x, { animationEnabled: m, as: "div", className: r(q(), c), children: I })
  ] });
}
const w = A.memo(H);
export {
  w as default
};
//# sourceMappingURL=Player.es.js.map
